<div #nodeEditorContainer class="cm-node-editor-container">
    <cm-node-editor-canvas #nodeEditorCanvas></cm-node-editor-canvas>
    <div #nodeContainer class="cm-node-container">
        <ng-content></ng-content>
    </div>
</div>
